import { Avatar } from "./Avatar"

interface MentionItem {
	_id: string
	avatar_url?: string
	display_name: string
	handle: string
}

interface MentionSuggestionsProps {
	items: MentionItem[]
	onSelect: (handle: string) => void
	selectedIndex: number
}

export function MentionSuggestions({ items, onSelect, selectedIndex }: MentionSuggestionsProps) {
	if (items.length === 0) {
		return null
	}

	return (
		<div className="max-h-[200px] overflow-y-auto border-app-border border-t bg-app-surface">
			{items.map((item, index) => (
				<button
					className={`flex w-full items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-app-surface-light ${
						index === selectedIndex ? "bg-app-surface-light" : ""
					}`}
					key={item._id}
					onMouseDown={e => {
						e.preventDefault()
						onSelect(item.handle)
					}}
					type="button"
				>
					<Avatar
						alt={item.display_name || item.handle}
						fallback={(item.display_name || item.handle)[0].toUpperCase()}
						size="xs"
						url={item.avatar_url}
					/>
					<div className="min-w-0 flex-1">
						<div className="truncate font-semibold text-app-text text-sm">{item.display_name}</div>
						<div className="truncate text-app-text-secondary text-xs">@{item.handle}</div>
					</div>
				</button>
			))}
		</div>
	)
}
